import { Controller } from "@hotwired/stimulus"

// RiepilogoProgetto.js: «Bando da guardare» (cambia) salva subito la scelta con PUT /projects/:id/bando-riferimento.
// Il menu resta al suo posto nel riquadro del bando e appartiene al form nascosto `cambia` (attributo form); la
// risposta (Turbo Stream) rende di nuovo il riepilogo, come carica() dopo il salvataggio.
//   <div data-controller="riepilogo"> … <select form="riepilogo-cambia-form" data-action="riepilogo#cambia">
//   <form id="riepilogo-cambia-form" hidden data-riepilogo-target="cambia">
// «Requisiti soddisfatti: scegli il bando…» (scegli) e' un <button type="button"> come nell'originale: invia il form
// nascosto `scegli` (POST /projects/:id/bandi-scelti/:gid).
export default class extends Controller {
  static targets = ["cambia", "scegli"]

  cambia() {
    if (this.hasCambiaTarget) this.cambiaTarget.requestSubmit()
  }

  scegli() {
    if (this.hasScegliTarget) this.scegliTarget.requestSubmit()
  }
}
